import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { StepsInfo } from './Utils/IvfLabelInput';
import useSnackbar from '../../../hooks/digitalMarketing/useSnackbar';
import { useDeleteIVFJourneystepMutation } from '../../../Service/ivfJourneyStage';
import useDeleteBox from '../../../hooks/digitalMarketing/useDeleteBox';
import AlertDialog from '../../../Component/DigitalMarketing/deleteConfirmation';

const DynamicPTags = (props) => {
  const { journey,submit,handleChangeInfo,onclick,stepdeleted,setStepdeleted,stepdeletedId,setStepdeletedId,setJourney } = props;
// console.log(journey);
const { open, message, openSnackBar, type } = useSnackbar();

// console.log(journey?.steps);
const array = Array.from({ length: journey?.steps.length }, (_, index) => journey?.steps[index]);

// Iterate over the array elements and log the index along with the element
array.forEach((element, index) => {
  // console.log(`Index: ${index}, Value:`, element);
});

  const [pTags, setPTags] = useState([]);
const newone =  <div key={pTags.length+2}>
          {/* <li className="input-custom" style={{backgroundColor:"#F7F7F7",padding:"15px",borderRadius:"6px",marginBlock:"5px"}} key={pTag.length}></li> */}
          <div className="d-flex justify-content-end">  <button  className="close-icon" onClick={() =>    openDelete(
        "Are you sure you want to delete this journey stage?",
        true,
        journey?.steps[pTags.length].id
    )
}>x</button></div>
        
          { StepsInfo.map((a, i) => (
        
       
        <li className="input-custom" key={i} style={{height:a.name=="stepdescription"?"130px":""}}>
          <a.tag
            img={a.img}
            journey={journey}
            label={a.label !== "Stepname" ? a.label : `${"Step "}${pTags.length+1}`}
            name={a.name}
            value={journey[a.key]}
            handleChange={handleChangeInfo}
            validation={a.validation}
            keyName={a.key}
            submit={submit}
          />
        </li>
     
    
  ))}  
   
          
        </div>;
  const addPTag = () => {
    setPTags([...pTags, newone]);
    // console.log(pTags);
    // console.log(journey);

    
  };

  useEffect(() => {
    if (journey?.steps.length === 0) {
      addPTag();
    } else {
      // console.log(journey?.steps.length);
      const newPTags = []; // Create a new array to hold the updated pTags
      
      // Loop over journey.steps.length instead of journey?.steps.length
      for (let index = 0; index < journey?.steps.length; index++) {
        const newone = (
          <div key={index}>
            {/* Render your content here */}
          </div>
        );
        newPTags.push(newone); // Push each newone into the newPTags array
      }
      setPTags(newPTags); // Set pTags to the new array of pTags
      // console.log(newPTags); // Log the updated pTags
    }
  }, []); // Add journey as a dependency to useEffect
  


  const removePTag = (indexToRemove) => {
    // console.log('Before removing:', pTags);
    // console.log('index', indexToRemove);
    // console.log(pTags);
    // console.log(journey);
    

    const updatedPTags = pTags.filter((pTag, index) => index !== indexToRemove);
    // console.log('After removing:', updatedPTags);
    setPTags(updatedPTags);
  }; 
  const [deleteJourneystep] =useDeleteIVFJourneystepMutation ();
  function findIndexById(stepsArray, idToFind) {
    for (let i = 0; i < stepsArray.length; i++) {
      if (stepsArray[i].id === idToFind) {
        return i; // Return the index if id matches
      }
    }
    return -1; // Return -1 if id is not found
  }
  const {
    open: open1,
    message: message1,
    openDelete,
    deleteId,
  } = useDeleteBox();
  const Delete = async (bool) => {
    if (bool) {
      try {
        await deleteJourneystep(deleteId).unwrap();
        openSnackBar("Deleted successfully");
        props.setStepdeletedId(deleteId);
        
        // After successful deletion, remove the step and update pTags
        removeStepAndFill(journey, deleteId);
        // removePTag(pTags.length);
       
        
        // Call the function to find the index
        // const idToFind = 59; // Specify the id to find
        const index = findIndexById(journey.steps, deleteId);
        // console.log("Index:", index); 
                removePTag(index);

      } catch (err: any) {
        openSnackBar(err.data.error, "error");
      }
    }
    openDelete("Are you sure you want to delete this User?", false, null);
  };
  
  async function removeStepAndFill(data, idToRemove) {
    // Remove the step with the specified id
    const filteredSteps = data.steps.filter(step => step.id !== idToRemove);
  
    // Update the id values of the remaining steps
    const updatedSteps = filteredSteps.map((step, index) => ({
      ...step,
      id: index  // Update the id to be the index in the array
    }));
  
    const newData = { ...data, steps: updatedSteps };
    // console.log(newData);

    // Call openDelete with necessary arguments
   

    // Define a function to handle post-deletion operations
  
        // Filter the newData object after openDelete completes
        const filteredData = {
            ...newData,
            steps: newData.steps.filter(step => step.id !== idToRemove)
        };
        // console.log('Filtered Data:', filteredData);

        // Update state with filtered data
        props.setJourney(filteredData);

        // Update other state variables (if necessary)
        // console.log(idToRemove);
        
        const updatedPTags = pTags.filter((pTag, index) => index !== idToRemove);
        // console.log('After removing:', updatedPTags);
        setPTags(updatedPTags);
 

    // Call handlePostDeletion after openDelete completes (assuming openDelete is asynchronous)
  
}



  useEffect(() => {
    

    // console.log(props.journey);
    // console.log(pTags);
    

  }, [props]);
  useEffect(() => {
    // console.log(pTags);

  }, [pTags])
  

  const handleChange = (index, content) => {
    setPTags(pTags.map((pTag, idx) => (idx === index ? content : pTag)));
  };
  

  return (
    <div>
      {/* <button onClick={addPTag}>Add New P Tag</button> */}
      <AlertDialog open={open1} message={message1} deleteBranches={Delete} />

      {pTags.map((pTag, index) => (
        <div key={index}>
          {/* <li className="input-custom" style={{backgroundColor:"#F7F7F7",padding:"15px",borderRadius:"6px",marginBlock:"5px"}} key={pTag.length}></li> */}
          <div className="d-flex justify-content-end">  <button  className="close-icon" onClick={() =>  journey?.steps[index] ? openDelete(
        "Are you sure you want to delete this journey stage?",
        true,
        journey?.steps[index].id
    ):                removePTag(index)

}>x</button></div>
        
          { StepsInfo.map((a, i) => (
            <>        
        <li className="input-custom" key={i} style={{height:a.name=="description"?"130px":""}}>
                 


          <a.tag 
            img={a.img}
            stepid={journey?.steps[index]?journey?.steps[index].id:index+2}
            label={a.label !== "Stepname" ? a.label : `${"Step "}${index+1}`}
            name={a.name}
            value={journey?.steps[index]?journey?.steps[index][a.key]:""}
            handleChange={handleChangeInfo}
            validation={a.validation}
            keyName={a.key}
            submit={submit}
          />
        </li>
     
    </>
  ))}  
   
          
        </div>
      ))}
      <Button onClick={addPTag} variant="contained" className="add-stage" style={{backgroundColor:"#F9F7FF",width: "125px",
height: "32px",margin:"0 0 40px 0",border:"1px solid #E6E6E6",boxShadow:"none",
color:"#000"}}  id="btn"><span style={{backgroundColor:"#6842D9",padding:"0 8px",borderRadius:"50%",color:"#fff"}} >+</span>&nbsp;&nbsp; Add Step</Button>
    </div>
  );
};

export default DynamicPTags;
